// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3fDuF","right":"Footer_right__2BCIs","buttons":"Footer_buttons__s7-Ms"};